function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.01 512.01",
    style: {
      enableBackground: "new 0 0 512.01 512.01"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M247.467,418.122h-17.083v-17.087c0-9.413-7.658-17.067-17.067-17.067H42.683c-9.408,0-17.067,7.654-17.067,17.067 v17.087H8.533c-4.717,0-8.533,3.821-8.533,8.533v51.2c0,4.712,3.817,8.533,8.533,8.533h238.933c4.717,0,8.533-3.821,8.533-8.533 v-51.2C256,421.943,252.183,418.122,247.467,418.122z M42.683,401.034h170.633v17.087H42.683V401.034z M238.933,469.322H17.067 v-34.133h221.867V469.322z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.158,270.168L258.244,152.814l10.917-23.531c0.044-0.086,0.114-0.148,0.155-0.236 c0.031-0.067,0.021-0.139,0.05-0.206l9.85-21.231c6.067-13.067,0.408-28.662-12.608-34.771l-95.483-44.75 c-3.492-1.637-7.208-2.467-11.042-2.467c-10.108,0-19.4,5.942-23.658,15.133l-9.958,21.465c-0.026,0.052-0.075,0.082-0.1,0.135 c-0.026,0.055-0.017,0.113-0.041,0.168L73.299,176.82c-0.026,0.052-0.075,0.082-0.099,0.135 c-0.025,0.054-0.017,0.113-0.041,0.167l-10.943,23.587c-6.067,13.075-0.408,28.671,12.608,34.767l95.483,44.754 c3.492,1.637,7.2,2.467,11.033,2.467c10.108,0,19.4-5.942,23.667-15.138l21.101-45.481l244.099,117.548 c2.367,1.158,4.9,1.742,7.442,1.742c1.933,0,3.883-0.338,5.758-1.012c4.442-1.6,7.967-4.879,9.933-9.229l17.092-37.767 C514.35,284.551,510.742,274.38,502.158,270.168z M151.908,47.934c1.475-3.188,4.683-5.246,8.175-5.246 c1.317,0,2.592,0.288,3.792,0.85l95.483,44.75c4.533,2.125,6.492,7.571,4.375,12.137l-6.331,13.645L145.455,61.844 L151.908,47.934z M189.525,260.376c-2.033,4.392-7.567,6.475-11.967,4.404l-95.492-44.758c-4.525-2.121-6.492-7.563-4.367-12.129 l7.406-15.964l111.932,52.254L189.525,260.376z M214.4,206.76c-0.03,0.059-0.087,0.093-0.116,0.153 c-0.034,0.07-0.023,0.146-0.055,0.217l-10.008,21.571L92.289,176.447l45.984-99.12l111.947,52.227L214.4,206.76z M494.858,286.376l-17.192,37.9L233.291,206.598l17.77-38.301L494.7,285.522C494.883,285.614,495.033,285.976,494.858,286.376z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuction);
export default __webpack_public_path__ + "static/media/auction.2fd6576bcf4e6d937df7d40ce8372801.svg";
export { ForwardRef as ReactComponent };